import styled from 'styled-components';
import { Link as LinkR } from 'react-router-dom';


export const CardLink = styled(LinkR)
`
    justify-self: flex-start;
    cursor: pointer;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    margin-left: 24px;
    margin-top: 24px;
    font-weight: bold;
    text-decoration: none;

`;